import { irMappingSlice } from './irMappingSlice';
import * as actions from './irMappingActions';
import * as selectors from './irMappingSelectors';

export { actions };
export { selectors };
export default irMappingSlice.reducer;